import Component from "../../component";
import {ProductItemImage} from "../product_item_image";
import {getRandomInt} from "../../helpers/number";

export const ProductItemConfig = {
  signature: 'productItem',
  baseHtmlClass: 'product_thumbnail',
  selector: '.product_thumbnail',
  initedHtmlClassModifier: 'inited',
  awakeHtmlClassModifier: 'awake',
  productItemConfigDataKey: 'productItemConfigData',

  imageSelector: '.product_thumbnail__image',
};

export class ProductItem extends Component {

  static applyToAll() {
    document.querySelectorAll(ProductItemConfig.selector).forEach((element) => {
      if (!ProductItem.isElementComponentized(element, ProductItemConfig.signature)) new ProductItem(element);
    });
  }

  constructor(id_or_element, props = {}) {
    super({
      element: id_or_element,
      config: ProductItemConfig
    });

    const configData = this.element[ProductItemConfig.productItemConfigDataKey] || {};
    this.prominence = configData['prominence'];
    this.isAvailable = configData['is_available'];
    this.isOnSale = configData['is_on_sale'];
    this.isOnSale = configData['is_best_seller'];
    this.collectionHandle = configData['collection_handle'];

    this.imageElement = this.element.querySelector(ProductItemConfig.imageSelector);
    if (this.imageElement) this.image = new ProductItemImage(this.imageElement);

    this.element.addEventListener('click', this.handleClick.bind(this));

    if (this.collectionHandle) {
      this.addHtmlClassState(`within_${this.collectionHandle}_collection`)
    }

    this.awake = false;
    setTimeout(this.awaken.bind(this), getRandomInt(1000, 5000));

    this.inited = true;
    this.render();
  }

  render() {
    this.conditionallySetHtmlClassState(this.awake, ProductItemConfig.awakeHtmlClassModifier);
    this.conditionallySetHtmlClassState(this.inited, ProductItemConfig.initedHtmlClassModifier);
  }

  handleClick(event) {
    const href = this.getHref();
    if (href) {
      event.preventDefault();
      window.location.assign(href);
    }
    ;
  }

  getHref() {
    let href = null;
    const linkElement = this.element.querySelector('a');
    if (linkElement) {
      href = linkElement.href;
    } else {
      console.warn('[ProductItem]:getHref():this: - Could not locate child link element', this);
    }
    return href;
  }

  awaken() {
    this.awake = true;
    this.render();
  }

}
